
import React from 'react';
import { motion } from 'framer-motion';

const About: React.FC = () => {
  return (
    <section id="about" className="py-32 bg-[#000000]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-zinc-600 text-[11px] uppercase tracking-[0.5em] font-bold mb-6">
              Philosophy
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold tracking-tight leading-tight mb-8">
              Engineering Excellence <br />
              <span className="text-zinc-500">Without Compromise.</span>
            </h3>
            <div className="space-y-6 text-zinc-400 text-lg font-medium leading-relaxed">
              <p>
                BloomHive is a specialized technology-driven development team focused on the intersection of modern engineering and intelligent systems. 
                We don't build simple websites; we architect complex digital ecosystems.
              </p>
              <p>
                Our core expertise lies in high-performance full-stack engineering, 
                Linux-based infrastructure, and custom AI integration that solves 
                real-world technical challenges.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid grid-cols-2 gap-4"
          >
            {[
              { label: 'Uptime', value: '99.9%' },
              { label: 'Security', value: 'Hardened' },
              { label: 'Architecture', value: 'Scalable' },
              { label: 'Integration', value: 'Seamless' },
            ].map((stat, i) => (
              <div 
                key={stat.label}
                className="p-8 rounded-3xl bg-[#080808] border border-white/5 flex flex-col items-center justify-center text-center group hover:border-violet-900/30 transition-colors"
              >
                <span className="text-3xl font-bold tracking-tighter mb-1 text-white group-hover:text-violet-400 transition-colors">{stat.value}</span>
                <span className="text-[10px] uppercase tracking-[0.3em] text-zinc-600 font-bold">{stat.label}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
